import { InjectionToken } from '@angular/core';
import { IContainerService } from './container-service.interface';

export const CONTAINER_SERVICE = new InjectionToken<IContainerService>(
  'CONTAINER_SERVICE'
);
